<template>
  <div class="talentType">
    <Search :title="chame" :attent="num + '项需关注'" :total="'共计' + total + '项'">
      <div v-if="gdb3">
        <van-cell v-for="(item,index) in talentTypeData" :key="index" :title="item.name" is-link  @click="$router.push('/talentInfo/' + item.id)">
          <template slot="label">
            <span class="need" v-if="item.summary !== '无需关注'">{{ item.summary }}</span>
            <span v-else>无需关注</span>
          </template>
        </van-cell>
      </div>
      <div v-if="gdb2">
        <van-cell v-for="(item,index) in talentTypeData" :key="index" :title="item.chname" is-link  @click="$router.push('/talentInfo/' + item.itemid)">
          <template slot="label">
            <span class="need">{{ parseInt(item.tag) === 1 ? '需要关注' : '无须关注'}}</span>
          </template>
        </van-cell>
      </div>
    </Search>
  </div>
</template>

<script>
import Search from '@/components/Search'
export default {
  name: 'talentType',
  data () {
    return {
      gdb3: false,
      gdb2: false,
      chame: this.$route.params.id,
      num: '',
      total: '',
      talentTypeData: []
    }
  },
  methods: {
    getTalentItems () {
      this.util.get(this.api.talent_items + '?system=' + this.chame, '', (success) => {
        this.talentTypeData = success.items
        this.num = success.quantity.attention
        this.total = success.quantity.total
        this.util.setLS('paginationData', success.items)
      })
    },
    // gdb2
    getTalentSystemInfo () {
      this.util.get1(this.api.talentSystemInfo + '?system=' + this.chame, '', (success) => {
        this.talentTypeData = success.list
        this.num = success.follow
        this.total = success.sum
      })
    }
  },
  mounted () {
    if (this.util.getLS(this.api.status) === 1) {
      this.gdb3 = true
      this.getTalentItems()
    } else {
      this.gdb2 = true
      this.getTalentSystemInfo()
    }
  },
  components: {
    Search
  }
}
</script>

<style scoped lang="scss">
  @import "../../assets/scss/functions";
  .talentType {
    .need {
      color: #007aff;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/talent/talentType.vue